/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for the MonitoredDomain model.
 * @export
 * @interface MonitoredDomain
 */
export interface MonitoredDomain {
    /**
     * 
     * @type {number}
     * @memberof MonitoredDomain
     */
    readonly id: number;
    /**
     * The domain name to monitor
     * @type {string}
     * @memberof MonitoredDomain
     */
    domainName: string;
    /**
     * Comma-separated tags for categorizing domains
     * @type {string}
     * @memberof MonitoredDomain
     */
    tags?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MonitoredDomain
     */
    readonly tagList: string;
    /**
     * Whether monitoring is active for this domain
     * @type {boolean}
     * @memberof MonitoredDomain
     */
    isActive?: boolean;
    /**
     * Additional information about this monitored domain
     * @type {string}
     * @memberof MonitoredDomain
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MonitoredDomain
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof MonitoredDomain
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the MonitoredDomain interface.
 */
export function instanceOfMonitoredDomain(value: object): value is MonitoredDomain {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('domainName' in value) || value['domainName'] === undefined) return false;
    if (!('tagList' in value) || value['tagList'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MonitoredDomainFromJSON(json: any): MonitoredDomain {
    return MonitoredDomainFromJSONTyped(json, false);
}

export function MonitoredDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'domainName': json['domain_name'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'tagList': json['tag_list'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function MonitoredDomainToJSON(json: any): MonitoredDomain {
      return MonitoredDomainToJSONTyped(json, false);
  }

  export function MonitoredDomainToJSONTyped(value?: Omit<MonitoredDomain, 'id'|'tag_list'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain_name': value['domainName'],
        'tags': value['tags'],
        'is_active': value['isActive'],
        'description': value['description'],
    };
}

